// extracted by mini-css-extract-plugin
module.exports = {"numberRange":"number-range___1p2gn","separator":"separator___1A3XD"};